import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  routers
} from './router';
import iView from 'iview';
import
store
  from '../Common/Store.js';
import Cookies from 'js-cookie'
Vue.use(VueRouter)

const RouterConfig = {
  // mode: 'history',
  routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  if (to.name == "Login" || to.name == "ResetPWD" || to.name == "SSOLogin" || to.name == "ChangePWD") {
    if (to.name == "Login" && Cookies.get("access_token") != "" && Cookies.get("access_token") != undefined && Cookies.get("access_token") != null) {
      next({
        name: 'SelectSystem',
      });
    } else {
      next();
    }
  } else if (Cookies.get("access_token") != "" && Cookies.get("access_token") != undefined && Cookies.get("access_token") != null) {
    next();
  } else {
    next({
      name: 'Login',
    });
  }
  // next();
});

router.afterEach((to) => {
  iView.LoadingBar.finish();
});



// WEBPACK FOOTER //
// ./src/router/index.js